
export const OEEventType = {
    mouse:                          'mouse',
    touch:                          'touch',
    unknown:                        'unknown',
};

export class OEEventHelper {

    constructor()   {
        this.mouseEvents = ['click', 'dblclick', 'mousedown', 'mouseup', 'mouseover', 'mouseout', 'mouseenter', 'mouseleave', 'mousemove'];

        this.touchEvents = ['touchstart', 'touchend', 'touchmove', 'touchcancel'];
    }

    getEventType(type)  {
        if(typeof(type) === 'object')   {
            return typeof(type.type) === 'string' ? this.getEventType(type.type) : OEEventType.unknown;
        }

        if(typeof(type) !== 'string')   return OEEventType.unknown;

        if(this.mouseEvents.includes(type)) return OEEventType.mouse;

        if(this.touchEvents.includes(type)) return OEEventType.touch;

        return OEEventType.unknown;
    }
    
    bubbleIframeEvents(iframe) {
        if(!iframe || iframe.contentWindow._isBubblingEvents) return;

        function mouseEventFn(e) {
            let boundingClientRect = iframe.getBoundingClientRect();

            let options = {
                bubbles:            true,
                cancelable:         e.cancelable,
                detail:             e.detail,
                view:               window,
                screenX:            e.screenX,
                screenY:            e.screenY,
                clientX:            e.clientX + boundingClientRect.left,
                clientY:            e.clientY + boundingClientRect.top,
                ctrlKey:            e.ctrlKey,
                shiftKey:           e.shiftKey,
                altKey:             e.altKey,
                metaKey:            e.metaKey,
                button:             e.button,
                buttons:            e.buttons,
                relatedTarget:      e.relatedTarget
            };

            let event = new MouseEvent(e.type, options);

            iframe.dispatchEvent(event);
        };

        function touchEventFn(e) {

            let options = {
                bubbles:            true,
                cancelable:         e.cancelable,
                detail:             e.detail,
                view:               window,
                touches:            e.touches,
                targetTouches:      e.targetTouches,
                ctrlKey:            e.ctrlKey,
                shiftKey:           e.shiftKey,
                altKey:             e.altKey,
                metaKey:            e.metaKey,
            };

            let event = new TouchEvent(e.type, options);

            iframe.dispatchEvent(event);
        };

        //
        iframe.contentWindow._isBubblingEvents = true;
        
        //
        if(!iframe._bubbleIframeEventsHandlers) iframe._bubbleIframeEventsHandlers = {};

        //
        this.mouseEvents.forEach(type => {
            if(iframe._bubbleIframeEventsHandlers[type]) iframe.contentWindow.removeEventListener(type, iframe._bubbleIframeEventsHandlers[type]);

            iframe._bubbleIframeEventsHandlers[type] = mouseEventFn;

            iframe.contentWindow.addEventListener(type, iframe._bubbleIframeEventsHandlers[type]);
        });

        this.touchEvents.forEach(type => {
            if(iframe._bubbleIframeEventsHandlers[type]) iframe.contentWindow.removeEventListener(type, iframe._bubbleIframeEventsHandlers[type]);

            iframe._bubbleIframeEventsHandlers[type] = touchEventFn;

            iframe.contentWindow.addEventListener(type, iframe._bubbleIframeEventsHandlers[type]);
        });
    }

    routeMouseEvents(src, options)  {
        if(!src) return;
        
        function constructEventHandler(type, eventType)  {
            return function(e){
    
                var opt = options || {};

                var clientShift = {x: 0, y: 0};

                var dst = opt.dst;

                if(!dst)    {

                    var savedStyle;

                    if(opt.hideElement) {
                        var savedStyle = opt.hideElement.style.display;
                        opt.hideElement.style.display = 'none';
                    }

                    dst = document.elementFromPoint(e.clientX, e.clientY);
                    if(!dst)    return;

                    if(dst.tagName.toLowerCase() === 'iframe')  {
                        //console.log('dst is iframe');

                        var iframe = dst;
                        var boundingClientRect = iframe.getBoundingClientRect();
                        clientShift = {x: -boundingClientRect.left, y: -boundingClientRect.top};
                        dst =  iframe.contentWindow.document.elementFromPoint(e.clientX + clientShift.x, e.clientY + clientShift.y);

                        if(!dst)    {
                            dst = iframe.contentWindow;
                        }
                    }

                    if(opt.hideElement) {
                        opt.hideElement.style.display = savedStyle;
                    }
                }

                var mouseEventInit = {
                    bubbles: true, // bubbles
                    cancelable: false, // not cancelable 
                    view: e.view,
                    detail: e.detail,
                    screenX: e.screenX,
                    screenY: e.screenY, 
                    clientX: e.clientX + clientShift.x, 
                    clientY: e.clientY + clientShift.y, 
                    ctrlKey: e.ctrlKey, 
                    altKey: e.altKey,
                    shiftKey: e.shiftKey, 
                    metaKey: e.metaKey,
                    button: e.button, 
                    relatedTarget: e.relatedTarget
                };

                var evt = null;

                if(eventType === 'MouseEvents')  {
                    evt = new MouseEvent(type, mouseEventInit);
                } else if(eventType === 'WheelEvent')   {
                    mouseEventInit.modifiersListArg = e.modifiersListArg;
                    mouseEventInit.deltaX = e.deltaX;
                    mouseEventInit.deltaY = e.deltaY;
                    mouseEventInit.deltaZ = e.deltaZ;
                    mouseEventInit.deltaMode = e.deltaMode;
                    evt = new WheelEvent(type, mouseEventInit);
                }
                
                dst.dispatchEvent(evt);
            };
        };

        function addEventHandler(type, eventType)  {
            src.addEventListener(type, constructEventHandler(type, eventType));
        };

        addEventHandler('click', 'MouseEvents');
        addEventHandler('dblclick', 'MouseEvents');
        addEventHandler('mousedown', 'MouseEvents');
        addEventHandler('mouseup', 'MouseEvents');
        addEventHandler('mouseover', 'MouseEvents');
        addEventHandler('mousemove', 'MouseEvents');
        addEventHandler('mouseout', 'MouseEvents');

        addEventHandler('wheel', 'WheelEvent');
    }
 }

export default new OEEventHelper();